import { ThemeEvents } from '@theme/events';

class StickySection extends HTMLElement {
  connectedCallback() {
    document.addEventListener(ThemeEvents.variantUpdate, this.updateContent.bind(this));
    const hideWhenVisible = document.querySelector(this.dataset.hideWhenVisible);
    const threshold = parseFloat(this.dataset.hideThreshold);
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), { threshold });
    this.observer.observe(hideWhenVisible);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdate, this.updateContent.bind(this));
    this.observer.disconnect();
  }

  handleIntersection(entries) {
    entries.forEach(entry => this.classList.toggle('hidden', entry.isIntersecting));
  }

  updateContent(event) {
    const newDoc = event.detail.data.html;
    const sectionId = this.dataset.sectionId;
    const newSection = newDoc.querySelector(`sticky-section[data-section-id="${sectionId}"]`);
    this.innerHTML = newSection.innerHTML;
  }
}

customElements.define('sticky-section', StickySection);
